import ReactGA from 'react-ga';
import TagManager from 'react-gtm-module'
import request from './request';

import HashCode from './HashCode';
import { getUserKey, setUserKey, getItineraryId, getSystemSettings, getDestination } from './SettingsRetriever';

const debug = false;
let sessionId = getUserKey();

export const initGA = (settings) => {
    let gaConfiguration = {};
    let tagConfiguration = {};
    let timestamp = parseInt(new Date().getTime() / 1000);

    if(sessionId) {
        if( (sessionId.timestamp + 3600) < timestamp ) {
            sessionId = false;
        }
    }

    if(!sessionId || !sessionId.timestamp) {
        sessionId = {
            id: HashCode(window.document.location.host+'+'+(timestamp)+'*'),
            timestamp: timestamp
        };
    }else{
        sessionId.timestamp = timestamp;
    }

    setUserKey(sessionId);

    if(settings && settings.analytics) {
        if(settings.analytics.ua) {
            gaConfiguration = settings.analytics.ua;
        }

        if(settings.analytics.gtm) {
            tagConfiguration = settings.analytics.gtm;
        }
    }

    if(gaConfiguration.code) {
        const gaArgs = {
            trackingId: gaConfiguration.code,
            debug: false,
            testMode: false,
            titleCase: false,
            gaOptions: {
                tracker: gaConfiguration.tracker,
                siteSpeedSampleRate: gaConfiguration.siteSpeedSampleRate || 5,
                clientId: sessionId.id
            }
        };

        ReactGA.initialize(gaArgs);
        if(debug){
            console.log('GA INIT', gaArgs);
        }
    }

    if(Array.isArray(tagConfiguration) || tagConfiguration.code) {
        if (Array.isArray(tagConfiguration)) {
            tagConfiguration.forEach(tagConfig => {
                initializeGTM(tagConfig)
            })
        } else {
            initializeGTM(tagConfiguration)
        }
    }
}

const initializeGTM = (gtmConfig) => {
    const tagManagerArgs = {
        gtmId: gtmConfig.code,
        dataLayer: {
            userProject: gtmConfig.project,
            userId: sessionId.id
        },
        dataLayerName: gtmConfig.project
    };

    TagManager.initialize(tagManagerArgs);
    if(debug){
        console.log('GTM INIT', tagManagerArgs);
    }
}

export const GAPageView = (eventData, type = 'page') => {
    const data = JSON.parse(JSON.stringify(eventData))
    if (data && data.data && data.data.customer) {
        if (data.data.customer.CCNumber) {
            data.data.customer.CCNumber = "X";
            data.data.customer.CCId = "X";
            data.data.customer.CCExpire = "X";
            data.data.customer.CCName = "X";
            data.data.customer.ccCvv = "X";
        }
    }
    let customConfiguration = false;
    if(data.globalSettings && data.globalSettings.analytics) {
        if(data.globalSettings.analytics.custom) {
            customConfiguration = data.globalSettings.analytics.custom;
        }
    }

    if(data && data.sectionSettings && data.sectionSettings.type) {
        if(data && data.sectionSettings && data.sectionSettings.title) {
        // setTimeout(function(){
            // ReactGA.pageview(data.sectionSettings.type);
            let title = data.sectionSettings.title;
            if(data && data.sectionSettings && data.sectionSettings.titleGA) {
                title = data.sectionSettings.titleGA;
            }
            ReactGA.pageview(window.location.pathname + window.location.search, [], title); 
        // }, 3000);

            if(debug){
                console.log('GA PAGE VIEW', data.sectionSettings.type);
            }
        }

        if(customConfiguration) {
            let trackEventArgs = {
                "session_id": sessionId.id,
            }

            if (type === 'page') {
                trackEventArgs = {
                    ...trackEventArgs, 
                    "page": data.sectionSettings.type,
                    "event": "Load",
                    "response": "Ok",
                    "data": {}
                }

                if(data.sectionSettings.code && data.sectionSettings.code !== data.sectionSettings.type) {
                    trackEventArgs.subpage = data.sectionSettings.code.toLowerCase();
                }
    
                if(data.page && data.page !== '') {
                    trackEventArgs.page = data.page.toLowerCase();
                }
    
                if(data.subpage && data.subpage !== '') {
                    trackEventArgs.subpage = data.subpage.toLowerCase();
                }
    
                if(data.email && data.email !== '') {
                    trackEventArgs.email = data.email.toLowerCase();
                }
    
                if(data.sectionSettings.productSupercategoryId) {
                    trackEventArgs.data.ProductSupercategoryId = parseInt(data.sectionSettings.productSupercategoryId);
                }
    
                if(data.sessionId && data.sessionId !== '') {
                    trackEventArgs.data.SessionId = data.sessionId;
                }
    
                if(data.globalSettings.app && data.globalSettings.app.salesid) {
                    trackEventArgs.data.SalesId = parseInt(data.globalSettings.app.salesid);
                }
    
                if (getItineraryId()) {
                    trackEventArgs.data._ItineraryID = getItineraryId();
                }
    
                if(data.data) {
                    trackEventArgs.data = {...trackEventArgs.data, ...data.data};
                }
            }

            if (type === 'event') {
                trackEventArgs = {
                    ...trackEventArgs,
                    "event": data.event,
                    "eventType": data.eventType
                }
            }

            request({
                url: customConfiguration.source + '/trackEvent.html',
                method: 'GET',
                params: trackEventArgs
            });
        }
    }
}

export const GAEvent = (event, eventType) => {
    GAPageView({event, eventType, globalSettings: getSystemSettings(), sectionSettings: {type: {}}}, 'event');
}

export const GATiming = (data) => {
    let customConfiguration = false;
    if(data.globalSettings && data.globalSettings.analytics) {
        if(data.globalSettings.analytics.custom) {
            customConfiguration = data.globalSettings.analytics.custom;
        }
    }
    // ReactGA.timing({
    //     category: categoryName, //String. Required. A string for categorizing all user timing variables into logical groups.
    //     variable: variableName, //String. Required. Name of the variable being recorded.
    //     value: valueNum, //Int. Required. Number of milliseconds elapsed time to report.
    //     label: '' //String. Optional. It can be used to add flexibility in visualizing user timings in the reports.
    // });
    if(data.initial && data.sectionSettings && data.sectionSettings.type) {
        const now = parseInt(new Date().getTime());
        const initial = parseInt(data.initial);

        let timingArgs = {
            category: data.sectionSettings.type,
            variable: 'load',
            value: (now - initial)
        }

        if(data.sectionSettings.code && data.sectionSettings.code !== data.sectionSettings.type) {
            timingArgs.category = data.sectionSettings.code.toLowerCase();
        }

        if(data.page) {
            timingArgs.category = data.page;
        }

        ReactGA.timing(timingArgs);

        if(debug) {
            console.log('ga timing', timingArgs);
        }

        if(customConfiguration) {
            let trackEventArgs = {
                "event": "LoadTime",
                "response": "Ok",
                "section": timingArgs.category,
                "count": timingArgs.value,
                "session_id": sessionId.id
            }

            if(data.data) {
                trackEventArgs.data = data.data;
            }

            request({
                url: customConfiguration.source + '/trackEvent.html',
                method: 'GET',
                params: trackEventArgs
            });
        }
    }
}

const getCurrency = () => {
    const systemSettings = getSystemSettings();
    let selectedCurrency = "USD";

    if (systemSettings && 
        systemSettings.app && 
        systemSettings.app.currency && 
        systemSettings.app.currency.list && 
        systemSettings.app.currency.default !== undefined && 
        systemSettings.app.currency.list[systemSettings.app.currency.default].base) {
        selectedCurrency = systemSettings.app.currency.list[systemSettings.app.currency.default].base;
    }
    return selectedCurrency;
}

const buildUniversalProducts = (prods, section = false, event) => {
    let gtmProducts = [];
  
    prods.forEach((prod, idx) => {
        let gtmProduct = {}
        if (event === "view_item_list") {
            gtmProduct.list = `Search Results ${section}`;
        } 

        // if we are before and AddToCart situation, quantity will be 0
        if (event === "view_item_list" || event === "view_item" || event === "productClick") {
            gtmProduct.quantity = 0
        } else {
            gtmProduct.quantity = prod.Quantity || prod.quantity || 1;
        }

        if (prod.PackageName) {
            gtmProduct.variant = prod.PackageName;
        }

        gtmProduct.position = idx;
        gtmProduct.name = prod.ProductName;
        gtmProduct.id = prod.ProductId;
        gtmProduct.price = getPrice(prod);
        gtmProduct.brand = prod.SupplierName;
        gtmProduct.category = prod.CategoryName ? prod.CategoryName.toLowerCase() : section;
        gtmProduct.sku = `${prod.SupplierId}-${prod.ProductId}`

        gtmProducts.push(gtmProduct);
    });
  
    return gtmProducts;
}


const buildAnalytics4Products = (prods, section = false, event) => {
    let gtmProducts = [];
    prods.forEach((prod, idx) => {
        let gtmProduct = {}
        if (event === "view_item_list") {
            gtmProduct.item_list_name = `Search Results ${section}`;
        } 

        // if we are before and AddToCart situation, quantity will be 0
        if (event === "view_item_list" || event === "view_item" || event === "select_item") {
            gtmProduct.quantity = 0
        } else {
            gtmProduct.quantity = prod.Quantity || prod.quantity || 1;
        }

        if (prod.PackageName) {
            gtmProduct.item_variant = prod.PackageName;
        }

        gtmProduct.index = idx;
        gtmProduct.item_name = prod.ProductName;
        gtmProduct.item_id = prod.ProductId;
        gtmProduct.price = getPrice(prod);
        gtmProduct.item_brand = prod.SupplierName;
        gtmProduct.item_category = prod.CategoryName ? prod.CategoryName.toLowerCase() : section;
        gtmProduct.currency = getCurrency();
        gtmProduct.sku = `${prod.SupplierId}-${prod.ProductId}`

        gtmProducts.push(gtmProduct);
    });
  
    return gtmProducts;
};

const buildOldProducts = (prods) => {
    const gtmProducts = [];
    let priceMode = "total";
    if (
      getSystemSettings().analytics &&
      getSystemSettings().analytics.config &&
      getSystemSettings().analytics.config.price
    ) {
      priceMode = getSystemSettings().analytics.config.price;
    }

    prods.forEach(item => {
        let itemPrice = parseFloat(item.Price);
        if (priceMode === "unitPrice") {
          itemPrice = itemPrice / item.Quantity;
        }

        gtmProducts.push({
            itineraryItemId: item.ItineraryItemId,
            sku: item.SKU,
            name: item.ProductName,
            category: item.CategoryName,
            price: parseFloat(itemPrice),
            quantity: item.Quantity,
            arrival_date: item.ArrivalDate,
            departure_date: item.DepartureDate,
            _PackageID: item.PackageId,
            _PackageName: item.PackageName,
            _AssociatedItineraryItemID: item.ParentItemId,
        })
    })

    return gtmProducts;
}

const getPrice = (product) => {
    // avoid getting prices from API like 598.999999991
    if (product.UnitaryPrice) {
        return product.UnitaryPrice
    }
    if (product.Supplier && product.Supplier.Pricing && product.Supplier.Pricing && product.Supplier.Pricing.price && product.Supplier.Pricing.price.perStay) {
        return Math.round(product.Supplier.Pricing.price.perStay * 100 ) / 100;
    }
    if (product.Pricing && product.Pricing.price && product.Pricing.price.perStay) {
        return Math.round(product.Pricing.price.perStay * 100 ) / 100;
    }
    if (product.FromPrice) {
        return Math.round(product.FromPrice * 100 ) / 100;
    }

    return Math.round(product.Price * 100 ) / 100;
}

const viewItemListEvent = (typeOfAnalytics, data, section) => {
    if (typeOfAnalytics === "universal") {
        return {
            ecommerce: {
                currencyCode: getCurrency(),
                impressions: buildUniversalProducts(data, section, "view_item_list")
            }
        };
    }
    
    return {
        event: "view_item_list",
        ecommerce: {
            items: buildAnalytics4Products(data, section, "view_item_list")
        }
    }
}

const productClickEvent = (typeOfAnalytics, data, additionalParam) => {
    /*  most of the time the additionalParam is going to be "lodging"
        needed to build product structure since lodging ones have different properties
    */
    if (typeOfAnalytics === "universal") {
        return {
            event: "productClick",
            ecommerce: {
                click: {
                    products: buildUniversalProducts([data], additionalParam, "productClick")
                }
            }
        }
    }
    return {
        event: "select_item",
        ecommerce: {
            items: buildAnalytics4Products([data], additionalParam, "select_item")
        }
    }
}

const viewItemEvent = (typeOfAnalytics, data, section) => {
    if (typeOfAnalytics === "universal") {
        return {
            ecommerce: {
                detail: {
                    products: buildUniversalProducts(data, section, "view_item")
                }
            }
        };
    }
    
    return {
        event: "view_item",
        ecommerce: {
            currency: getCurrency(),
            value: getTotalRevenue(data),
            items: buildAnalytics4Products(data, section, "view_item")
        }
    }
}

const viewCartEvent = (typeOfAnalytics, data, additionalParam) => {
    if (typeOfAnalytics === "universal") return null;

    return {
        event: "view_cart",
        ecommerce: {
            currency: getCurrency(),
            value: additionalParam,
            items: buildAnalytics4Products(data)
        }
    }
}

const addToCartEvent = (typeOfAnalytics, data, additionalParam) => {
    if (typeOfAnalytics === "universal") {
        return {
            event: "addToCart",
            ecommerce: {
                currencyCode: getCurrency(),
                add: {
                  products: buildUniversalProducts(data, additionalParam)
                }
            }
        }
    }
    
    return {
        event: "add_to_cart",
        ecommerce: {
            currency: getCurrency(),
            value: getTotalRevenue(data),
            items: buildAnalytics4Products(data, additionalParam)
        },
    };
}

const removeFromCartEvent = (typeOfAnalytics, data) => {
    if (typeOfAnalytics === "universal") {
        return {
            event: "removeFromCart",
            ecommerce: {
                remove: {
                  products: buildUniversalProducts(data)
                }
            }
        }
    }

    return {
        event: "remove_from_cart",
        ecommerce: {
          value: getTotalRevenue(data),
          items: buildAnalytics4Products(data),
        },
    };
}

const checkoutEvent = (typeOfAnalytics, data, additionalParam) => {
    if (typeOfAnalytics === "universal") {
        return {
            event: "checkout",
            ecommerce: {
                checkout: {
                    actionField: {
                        step: additionalParam.step,
                        option: additionalParam.option,
                    },
                    products: buildUniversalProducts(data)
                }
            },
        }
    } 

    if (additionalParam.step === 1) {
        return {
            event: "begin_checkout",
            ecommerce: {
                currency: getCurrency(),
                value: getTotalRevenue(data),
                items: buildAnalytics4Products(data)
            }
        }
    }

    if (additionalParam.step === 2) {
        return {
            event: "add_payment_info",
            ecommerce: {
                currency: getCurrency(),
                items: buildAnalytics4Products(data),
                payment_type: getPaymentType(additionalParam),
                value: getTotalRevenue(data)
            }
        }
    }

    return false;
}

const getPaymentType = (customerInfo) => {
    if (customerInfo && customerInfo.customerData && customerInfo.customerData.paymentType) {
        switch(customerInfo.customerData.paymentType) {
            case 1:
                return "Credit Card"
            case 4:
                return "Pay Later"
            case 14:
                return "Affirm" 
            default:
                return ""
        }
    }
    return ""
}

const getTotalRevenue = (itinerary) => {
    let totalPrice = 0;
    itinerary.forEach(product => {
        if (product.Price === 0) {
            return;
        }
        
        if (!product.Price) {
            if(product && product.Pricing && product.Pricing.price && product.Pricing.price.perStay) {
                totalPrice += product.Pricing.price.perStay;
            }
        } else {
            totalPrice += parseFloat(product.UnitaryPrice || product.Price);
            totalPrice = totalPrice * product.Quantity;
            // removed them as instructed, only in purchase they will appear
            // if (product.TaxesFees) {
            //     totalPrice += parseFloat(product.TaxesFees)
            // }
        }
    })

    return totalPrice;
}

const viewWaiverEvent = () => {
    return {
        event: "view_waiver"
    }
}

const fillWaiverEvent = (data) => {
    return {
        event: "fill_waiver",
        ecommerce: {
            waivers: data
        }
    }
}

const purchaseEvent = (typeOfAnalytics, data, additionalParam) => {
    if (typeOfAnalytics === "universal") {
        return {
            ecommerce: {
                purchase: {
                    actionField: {
                        id: data.itineraryid,                     // Transaction ID. Required for purchases and refunds.
                        affiliation: '',
                        revenue: parseFloat(data.subtotal),                 // Total transaction value (incl. tax and shipping)
                        tax: parseFloat(data.tax),
                        shipping: 0,
                    },
                    currency: getCurrency(),
                    products: buildUniversalProducts(data.products, false, "purchase")
                }
            }
        };
    }
    
    if (typeOfAnalytics === "ga4") {
        return {
            event: "purchase",
            ecommerce: {
                transaction_id: data.itineraryid,
                affiliation: '',
                value: parseFloat(data.subtotal),
                tax: parseFloat(data.tax),
                shipping: 0,
                currency: getCurrency(),
                items: buildAnalytics4Products(data.products, false, "purchase")
            }
        }
    }

    // old event below

    const oldData = {
        event: 'conversion',
        transactionId: ''+data.itineraryid+'',
        transactionAffiliation: '',
        transactionTotal: parseFloat(data.subtotal),
        transactionTax: parseFloat(data.tax),
        transactionShipping: 0,
        transactionProducts: buildOldProducts(data.products)
    }
    if (getSystemSettings().multiDestination && getDestination() && getDestination()[0]){
        let destination = getSystemSettings().multiDestination.list.find(dest => dest.id === getDestination()[0])
        if (destination){
            oldData.brandId = destination.id
            oldData.brandName = destination.name
        }
    }

    return oldData;
    
}

const getGtmObject = (typeOfAnalytics, event, data, additionalParam) => {
    switch(event) {
        case "view_item_list":
            return viewItemListEvent(typeOfAnalytics, data, additionalParam);
        case "view_item":
            return viewItemEvent(typeOfAnalytics, data, additionalParam);
        case "productClick": 
            return productClickEvent(typeOfAnalytics, data, additionalParam);
        case "view_cart":
            return viewCartEvent(typeOfAnalytics, data, additionalParam);
        case "addToCart": 
            return addToCartEvent(typeOfAnalytics, data, additionalParam);
        case "removeFromCart": 
            return removeFromCartEvent(typeOfAnalytics, data);
        case "checkout":
            return checkoutEvent(typeOfAnalytics, data, additionalParam);
        case "view_waiver":
            return viewWaiverEvent(typeOfAnalytics, data);
        case "fill_waiver":
            return fillWaiverEvent(typeOfAnalytics, data);
        case "purchase":
            return purchaseEvent(typeOfAnalytics, data, additionalParam);
        default: 
        break;
    }
}

export const gtmFunction = (event, data, additionalParam = false) => {
    let tagConfiguration = false;
    let globalSettings = getSystemSettings();
    if(globalSettings && globalSettings.analytics) {
        if(globalSettings.analytics.gtm) {
            tagConfiguration = globalSettings.analytics.gtm;
        }
    }

    if(tagConfiguration) {
        if(event === 'purchase') {
            additionalParam = tagConfiguration.project
        }

        if (Array.isArray(tagConfiguration)) {
            /* if multiple GTM codes, the name of each project must be specified */
            tagConfiguration.forEach((tagConfig, index) => {
                let typeOfAnalytics = tagConfig.typeOfAnalytics;
                return (
                    TagManager.dataLayer({ dataLayer: { ecommerce: null }, dataLayerName: tagConfig.project }),
                    TagManager.dataLayer({ dataLayer: getGtmObject(typeOfAnalytics, event, data, additionalParam), dataLayerName: tagConfig.project })
                ) 
            })
        } else {
            let typeOfAnalytics = tagConfiguration.typeOfAnalytics;
            if (event === "cookie_consent" && globalSettings && globalSettings.id === 64) {
                TagManager.dataLayer({ dataLayer: { OnetrustActiveGroups: ",C0001,C0002,C0003,C0004," }, dataLayerName: tagConfiguration.project });
            }
            TagManager.dataLayer({ dataLayer: { ecommerce: null } });
            TagManager.dataLayer({ dataLayer: getGtmObject(typeOfAnalytics, event, data, additionalParam), dataLayerName: tagConfiguration.project });
        }

    }
}
    